import ListBonDocuments from "./ListBonDocuments";

const ListBonRetour = () => (
  <ListBonDocuments
    transactionType={2}
    title="Bons de retour"
    icon="fa-undo-alt"
    subtitle="Consultez les bons de retour d'un dépôt sur une période"
    singular="bon de retour"
    plural="bons de retour"
  />
);
export default ListBonRetour;
